import { CompanyAvatar } from "@components/common/company-avatar";
import { SphereTooltip } from "@components/common/sphere-tooltip";
import { SdbCompany } from "@custom-types/sdb-company-types";
import { Box } from "@mui/material";
import { blue, neutral } from "@flat-ui";
import { DEFAULT_INPUT_FONT_SIZE, withEllipsis } from "@styles/common-styles";
import { formatUserRoleType } from "@utils/data-display";

interface Props {
  /** The workspace to be displayed, can be the admin panel or a normal workspace */
  sdbCompany: SdbCompany;

  /** Optional function to be called when the item is clicked */
  onClick?: () => void;
}

export const LINK_HEIGHT = "70px";

/**
 * Shows a the link for a workspace to be selected in the workspaces selection page.
 */
export function SelectWorkspaceLink({
  sdbCompany,
  onClick,
}: Props): JSX.Element {
  return (
    <Box
      component="a"
      href={sdbCompany.url}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: neutral[0],
        height: LINK_HEIGHT,
        paddingX: "20px",
        borderRadius: "4px",
        // Needed to avoid the decoration because we are using a link
        textDecoration: "none",
        // Needed to avoid the decoration because we are using a link
        color: "inherit",
        "&:hover": {
          boxShadow: `0 0 0 1px ${blue[500]}`,
          cursor: "pointer",
        },
      }}
      onClick={onClick}
    >
      <Box
        component="div"
        sx={{
          display: "flex",
          alignItems: "center",
          ...withEllipsis,
        }}
      >
        <Box component="div" width="32px">
          <CompanyAvatar
            name={sdbCompany.name}
            color={sdbCompany.type === "admin" ? neutral[1000] : blue[500]}
            size="x-large"
          />
        </Box>
        <SphereTooltip
          title={<var>{sdbCompany.name}</var>}
          boxProps={{
            sx: {
              ...withEllipsis,
              marginX: "20px",
              fontSize: DEFAULT_INPUT_FONT_SIZE,
              fontWeight: "500",
            },
          }}
        >
          <var>{sdbCompany.name}</var>
        </SphereTooltip>
      </Box>
      {sdbCompany.role.company && (
        <Box
          component="div"
          sx={{
            fontSize: DEFAULT_INPUT_FONT_SIZE,
          }}
        >
          {formatUserRoleType(sdbCompany.role.company) ?? ""}
        </Box>
      )}
    </Box>
  );
}
